import { graphql } from 'react-apollo'
import { Layout, Table, Button, Input } from 'antd'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import labelGroupQuery from '../graphql/queries/labelGroup'
import Navbar from '../components/Navbar'

import '../css/table.css'

const { Content } = Layout

class TrackingJandtGroup extends Component {
  state = {
    searchKey: '',
  }
  render(){

    const searchKey = this.state.searchKey.toLowerCase()
    const { labelGroup: { loading, labelGroup = [] } } = this.props
    let groups = labelGroup.map(group => ({ group }))
    if(searchKey !== ''){
      groups = groups.filter(groupData => groupData.group.toLowerCase().includes(searchKey))
    }
    const columns = [
      {
        title: 'Group',
        key: 'group',
        render: record => (<Link to={`/trackingjandt/${record.group}`}>{record.group}</Link>),
      },
      {
        title: 'Create Tracking',
        key: 'createtracking',
        width: 150,
        className: 'text-center',
        render: record => (<Link to={`/trackingjandt/${record.group}`}><Button>Create</Button></Link>),    
      },
    ]
    return (
      <Layout>
        <Navbar selected="label:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>Label Group</h2>
            <Input.Search placeholder='Search Group' style={{ float: 'right', marginBottom: '10px', width: '250px'}} onChange={ e => this.setState({searchKey: e.target.value})} /><br />
            <Table
              dataSource={groups}
              columns={columns}
              rowKey="group"
              pagination={{ pageSize: 50 }}
              size="middle"
              loading={loading}
              bordered
            />
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
TrackingJandtGroup.propTypes = {
  labelGroup: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    labelGroup: PropTypes.array,
  }).isRequired,
}
TrackingJandtGroup.defaultProps = {}

export default graphql(labelGroupQuery, { name: 'labelGroup' })(TrackingJandtGroup)



// WEBPACK FOOTER //
// ./src/pages/TrackingJandtGroup.js